import React from "react";
import { ExternalLink } from "lucide-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogClose,
} from "components/ui/dialog";
import { Button } from "components/ui/button";

function InfoModal({ showInfoModal, setShowInfoModal, theme }) {
    function openConfluenceUrl() {
        window.open(
            "https://m2amedia.atlassian.net/wiki/spaces/OP/pages/3976855574/Streamcheck+-+Event+Healthcheck+Ops+1st+step+in+Triage",
            "_blank",
            "noreferrer"
        );
    }

    return (
        <Dialog open={showInfoModal} onOpenChange={setShowInfoModal}>
            <DialogContent className="max-w-lg">
                <DialogHeader>
                    <DialogTitle>Info</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 text-sm">
                    <p>
                        This tab shows the overall health of a live event. Enter an{" "}
                        <strong>Event ID</strong> and <strong>Environment</strong>, pick a
                        time window (1H / 2H / custom range), then <strong>Filter</strong> to
                        load the cards.
                    </p>
                    <p>
                        Each card runs a CloudWatch Logs Insights query against the{" "}
                        <code>origin-cache-router-access</code> log group. A green message
                        means the metric looks healthy; a table or warning flags something to
                        look into. Use the <strong>Columns</strong> control to fit more or
                        larger charts, and a card's <strong>view</strong> (eye) button to open
                        a full-size chart with the underlying data and per-query guidance.
                    </p>
                    <p>
                        For details on how to read each query and triage from here, see the{" "}
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={openConfluenceUrl}
                            title="Open in console"
                        >
                            Confluence page
                            <ExternalLink />
                        </Button>
                    </p>
                </div>
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="secondary">Close</Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default InfoModal;
